module.exports = __webpack_public_path__ + "img/tech_the_idea_behind_the_project.a5e2e827.png";